var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('table-page-wrapper',{staticClass:"categories-offers",attrs:{"title":"Категории офферов","settings-title":"Категории офферов","error-text":"Список категорий офферов не загружен","columns":_vm.columns,"filters":_vm.filters,"table-options":_vm.categoriesTable}})
}
var staticRenderFns = []

export { render, staticRenderFns }